export const tabs = [
  { label: 'Home', value: 'home' },
  { label: 'Containers', value: 'containers' },
  { label: 'Notes', value: 'notes' },
]
